var BlockView = require('views/block/base-block-view');
var utils = require('lib/utils');
const DOMPurify = require('dompurify');

var ImageView = BlockView.extend({
  className: 'images',
  initialize: function() {
    _.each(this.model.get('images'), this.applyCustomization);
  
    if(this.model.get('images')) {
      this.model.get('images').forEach(function(image) {
        if(image.srcset) {
          image.srcset = image.srcset.join(', '); 
        }
      });
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },

  applyCustomization: function(image) {
    if(image.custom_image_slug) {
      var customization = EF.customizations.getByKeyAndSlug('image-content-customization', image.custom_image_slug);

      if(customization) {
        image.path = customization.url; //assume the url is absolute
      } else if(image.path) {
        image.path = utils.coursePath(image.path);  //no customization found, assume url is relative
      } else {
        image.path = undefined; //customization not resolved and no path, render nothing
      }
    } else if(image.path) {
      image.path = utils.coursePath(image.path);  //page is not calling for customization, assume url is relative
    }
  },

  load: function() {
    if(this.model.get('svg')) {
      fetch(utils.coursePath(this.model.get('svg'))).then(r => r.text()).then(svg => {
        const wrapperSvg = document.createElement('div');
        wrapperSvg.innerHTML = DOMPurify.sanitize(svg);
        this.el.appendChild(wrapperSvg);
      });
    }
  },

  play: function() {
    this.readyToGo();
  }
});

module.exports = ImageView;
